<template>
  <table-view
    class="water-fee-record"
    :total="total"
    :query-info.sync="queryInfo"
    @reload-table="renderTable">
    <template #header>
      <el-tabs v-model="waterType" @tab-click="handleWaterType" type="card">
        <el-tab-pane label="掌控水表" name="1">
          <view-search-form
            v-if="+waterType===1"
            v-loading="loading"
            keyword-placeholder="姓名、订单编号"
            :query-info.sync="queryInfo"
            :tool-list="['keyword']"
            @on-search="renderTable(1)"
            label-width="60px"
          >
            <el-form-item label="记录类型" prop="dormitoryId">
              <el-select size="small" clearable v-model="queryInfo.useType" @change="renderTable(1)">
                <el-option v-for="item in Object.entries(useTypeMap)" :key="item[0]" :label="item[1]"
                           :value="+item[0]" />
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker
                type="date"
                placeholder="开始日期"
                size="small"
                :picker-options="comptStartTime"
                v-model="queryInfo.startDate"
                style="width: 100%"
                value-format="yyyy-MM-dd" />
            </el-form-item>
            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker
                type="date"
                placeholder="结束日期"
                size="small"
                :picker-options="comptEndTime"
                v-model="queryInfo.endDate"
                style="width: 100%"
                value-format="yyyy-MM-dd" />
            </el-form-item>
            <el-form-item label="宿舍楼" prop="dormitoryId">
              <el-select size="small" filterable clearable v-model="queryInfo.dormitoryId" @change="changeDormBuild">
                <el-option
                  v-for="{dormitoryName, id} in dormBuildList"
                  :label="dormitoryName"
                  :value="id"
                  :key="id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="楼层" prop="floorNum">
              <el-select size="small" filterable clearable v-model="queryInfo.floorNum" @change="getDormRoomList">
                <el-option
                  v-for="num in floorNumList"
                  :label="`第${num}层`"
                  :value="num"
                  :key="num"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="宿舍" prop="floorNum">
              <el-select size="small" filterable clearablev-model="queryInfo.roomId">
                <el-option
                  v-for="{roomName , sexType , id} in roomList"
                  :label="`${roomName}(${+sexType===1?'男':'女'}生宿舍)`"
                  :value="id"
                  :key="id" />
              </el-select>
            </el-form-item>
          </view-search-form>
        </el-tab-pane>
        <el-tab-pane label="新水表" name="2">
          <view-search-form
            v-if="+waterType===2"
            v-loading="loading"
            keyword-placeholder="姓名、订单编号"
            :query-info.sync="queryInfo"
            :tool-list="[]"
            label-width="80px"
            @on-search="renderTable(1)"
          >
            <el-form-item label="远程搜索用户" label-width="100px">
              <tool-tips-group is-flex
                               tips-content="远程搜索学生/教职工，从返回的下拉列表中选中目标。<br/>名字搜索最少输入2个汉字，<br/>身份证/录取编号搜索最少输入6位数字。<br/>选择了用户后，才能进行日期筛选。">
                <el-autocomplete
                  class="input-with-radio"
                  v-model="userInfo"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="学生名、身份证号、录取编号"
                  size="small"
                  clearable
                  @select="handleSelect" style="width: 400px;">
                  <el-radio-group size="small" v-model="userType" slot="prepend">
                    <el-radio-button :label="2">学生</el-radio-button>
                    <el-radio-button :label="3">教职工</el-radio-button>
                  </el-radio-group>
                </el-autocomplete>
              </tool-tips-group>
            </el-form-item>
            <el-form-item label="开始时间" prop="startDate">
              <el-date-picker type="datetime" size="small" placeholder="开始时间" v-model="queryInfo.startDate"
                              format="yyyy-MM-dd HH:mm"
                              style="width: 100%" value-format="yyyy-MM-dd HH:mm:00" />
            </el-form-item>
            <el-form-item label="结束时间" prop="startDate">
              <el-date-picker type="datetime" size="small"
                              :picker-options="pickerOptions"
                              placeholder="结束时间" v-model="queryInfo.endDate"
                              format="yyyy-MM-dd HH:mm"
                              style="width: 100%" value-format="yyyy-MM-dd HH:mm:59" />
            </el-form-item>
          </view-search-form>
        </el-tab-pane>
      </el-tabs>

    </template>
    <el-table v-if="!loading" v-loading="loading" :data="tableData" style="width: 100%" border stripe>
      <el-table-column type="index" label="ID" width="50" />
      <el-table-column prop="stuName" label="姓名" width="110" />
      <el-table-column label="记录类型" min-width="100" align="center">
        <template v-slot="{ row }">
          {{ useTypeMap[row.useType] ? useTypeMap[row.useType] : '' }}
        </template>
      </el-table-column>
      <el-table-column label="日期" width="160" align="center">
        <template v-slot="{row}">
          {{ (row.updateTime || row.createTime)|formatDate('YYYY-MM-DD HH:mm') }}
        </template>
      </el-table-column>
      <el-table-column prop="useMinutes" label="用水时长" width="90" />
      <el-table-column prop="useWater" label="已用水量" width="90" />
      <el-table-column prop="balance" label="用水余量" width="90" />
      <el-table-column prop="className" label="宿舍" min-width="300">
        <template v-slot="{ row }">
          {{ row.roomName ? (row.dormitoryName + row.floorNum + '层' + row.roomName + '房') : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="collegeName" label="院系" width="150" />
      <el-table-column prop="majorName" label="专业" min-width="180" />
      <el-table-column prop="className" label="班级" min-width="180" />
      <el-table-column prop="remarks" label="备注" min-width="200px" />
    </el-table>
  </table-view>
</template>

<script>
import tableView from '@/vue/mixins/table-view'
import { pageNewWaterUsageRecordApi, pageStuWaterFeeRecordApi } from '@/api/dorm/water-fee-record-api'
import { getUserAll } from '@/api/system/user-api'

export default {
  name: 'waterFeeRecord',
  mixins: [tableView],
  data() {
    return {
      userType: 2, // 2-学生 3-管理员 1-教师
      waterType: '1',
      queryInfo: {},
      // 用水类型
      useTypeMap: {
        2: '用水记录',
        0: '开水记录',
        3: '关水记录'
      },
      // 远程搜索住户
      userInfo: '',
      dormBuildList: [],
      roomList: [],
      floorNumList: 0,
      pickerOptions: {
        disabledDate: (time) => {
          const timesValue = this.$moment(this.queryInfo.startDate || time).valueOf()
          const _endTime = this.$moment(this.queryInfo.endDate).valueOf()
          return timesValue > _endTime
        }
      }
    }
  },
  computed: {
    comptStartTime() { // 开始日期不能早于结束日期
      let _endTime = 0
      if (this.queryInfo.endDate) {
        _endTime = this.queryInfo.endDate.replace(/-/g, '/')
        _endTime = new Date(_endTime).getTime()
      }
      return {
        disabledDate: time => {
          if (_endTime) {
            return time.getTime() > _endTime
          }
        }
      }
    },
    comptEndTime() { // 结束日期不能早于开始日期
      let _startTime = 0
      if (this.queryInfo.startDate) {
        _startTime = this.queryInfo.startDate.replace(/-/g, '/')
        _startTime = new Date(_startTime).getTime()
      }
      return {
        disabledDate: time => {
          if (_startTime) {
            return time.getTime() < _startTime
          }
        }
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.handleWaterType(),
      this.getRoomBuildList()
    ])
  },
  methods: {
    async renderTable(pageNum) {
      // 1-掌控水表 2-新水表
      const _api = +this.waterType === 2 ? pageNewWaterUsageRecordApi : pageStuWaterFeeRecordApi
      // 新水表只能搜索指定用户的用水记录
      if (this.waterType === 2 && !this.queryInfo.userId) {
        this.$message.error('请先选择用户')
        return
      }
      await this.getTableData(_api, pageNum)
    },
    async handleWaterType() {
      switch (+this.waterType) {
        case 2:
          // 不存在 userId，就不用搜索了
          this.queryInfo = {
            userId: null,
            startDate: null,
            endDate: null
          }
          break
        default:
          this.queryInfo = {
            startDate: this.$moment().format('YYYY-MM-DD'),
            endDate: null,
            dormitoryId: null,
            floorNum: null,
            roomId: null,
            useType: 2
          }
          console.log('this.queryInfo', this.queryInfo)
          // await this.renderTable(1)
          break
      }
    },
    // 获取宿舍楼栋
    async getRoomBuildList() {
      try {
        const res = await this.$http.listDormitoryApi({})
        this.dormBuildList = res.data
      } catch (e) {
      }
    },
    // 选择楼栋
    changeDormBuild(dormitoryId) {
      this.queryInfo.floorNum = null
      this.queryInfo.roomId = null
      this.clearList(this.roomList)
      if (dormitoryId) {
        this.floorNumList = this.dormBuildList.filter(
          (item) => item.id === dormitoryId
        )[0].floorAmount
      }
    },
    // 获取宿舍列表
    getDormRoomList() {
      this.clearList(this.roomList)
      this.queryInfo.roomId = null
      this.$http
        .getDormRoomQuery({
          dormitoryId: this.queryInfo.dormitoryId,
          floorNum: this.queryInfo.floorNum
        })
        .then((res) => {
          this.roomList = res.data
        })
    },
    // 远程搜索 学生名
    async querySearchAsync(keyword, cb) {
      let _result = []
      /* 判断是否请求接口 为false 时请求接口
      * 默认为 true ,因为为false+keyword===''时加载所有的几万条学生数据
      * */
      let _correctQuery = false
      if (keyword) {
        if (!isNaN(keyword)) {
          // 支持学号、身份证号(number)搜索,但是学号/考号/身份证号必须填入6位数以上,减轻服务器压力
          if (keyword.length > 5) {
            _correctQuery = true
          }
        } else if (keyword.length > 1) {
          // 为string,且关键字大于一个字才能开始搜索,减轻服务器压力
          _correctQuery = true
        }
      }
      if (_correctQuery) {
        if (this.userType === 2) {
          // 学生查询
          this.$http.getStudentListQuery({
            keyword: keyword
          }).then((res) => {
            res.data.map((stu) => {
              stu.value = `${stu.examineNo}-${stu.stuName}(身份证:${stu.idNumber})`
            })
            _result = res.data
            if (_result.length) this.queryInfo.userId = null
            cb(_result)
          })
        } else {
          //   1/3都是教职工
          try {
            const res = await getUserAll({ realName: keyword })
            res.data.map((item) => {
              item.value = item.realName
            })
            // result = res.data
            cb(res.data)
          } catch (e) {
            console.error(e)
          }
        }
      } else {
        // 先清空，再开始搜索
        this.queryInfo.userId = null
        cb(_result)
      }
    },
    // 获取选中的学生信息
    handleSelect(target) {
      if (target) {
        this.queryInfo.userId = target.id
        this.renderTable(1)
      }
    }
  }
}
</script>
<style lang="scss">
.input-with-radio {
  .el-input-group__prepend {
    padding: 0;
    background-color: #fff;

    .el-radio-button__inner {
      border-radius: 0;
      border: 0;
      border-right: 1px solid #dcdfe6;
    }
  }
}
</style>
